import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Conditional + Tailwind-aware className composer.
 *
 * Pattern: `cn("base", condition && "active", className)` — duplicate /
 * conflicting Tailwind utilities are de-duplicated by `twMerge` (e.g.
 * `cn("px-2", "px-4")` → `"px-4"`).
 *
 * Single source of truth — every component in `@ando/ui` and every app
 * consumes this helper to keep behaviour identical (DRY across the
 * monorepo, no per-app drift).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
